import cuid from 'cuid'
import _ from 'lodash'
import ConfigurationService from '../../components/configuration/configuration.service'
import sharedService from '../../utils/shared-service'
import { CONSTANT, SCOF_AUTH_NTS } from '../../utils/constant.js'
import utils from '@/utils/utils'

const configurationService = new ConfigurationService()

const state = configurationService.getConfigData()

const getters = {

  quickCartProducts (state) {
    return state.storefront.quickCart.products
  },

  currencySymbol (state) {
    return _.find(CONSTANT.CONFIG.CURRENCIES, ['code', state.storefront.currency]).symbol || '&#36;'
  },

  currencyCode (state) {
    return _.find(CONSTANT.CONFIG.CURRENCIES, ['code', state.storefront.currency]).code || 'USD'
  },

  advanced (state) {
    return state.advanced
  },

  srcEntityIds (state) {
    return state.checkout.srcEntityIds
  },

  dpaIds (state) {
    return state.checkout.dpaIds
  },

  scofDpaId (state) {
    let cofDpaIds = state.checkout.dpaIds.filter((dpa) => {
      return dpa['displayDpaName'].includes('COF')
    })
    let dpaId = cofDpaIds[0]
    return dpaId.dpa[0].dpaId
  },

  checkout (state) {
    return state.checkout
  },

  isSRCCheckoutDisabled (state) {
    return state.isSRCCheckoutDisabled
  },

  apiEndpoints (state) {
    return state.advanced.paymentProcessor
  },

  cardStatus (state) {
    return state.cardStatus
  },

  srcId (state) {
    return state.checkout.srcId || ''
  },

  dpaId (state) {
    return state.checkout.dpaId || ''
  },

  enrollCard (state) {
    return state.enrollCard
  },

  federatedToken (state) {
    return state.federatedToken
  },

  userAccessToken (state) {
    return state.userAccessToken
  },

  adminUserName (state) {
    return state.adminUserName
  },

  srcKeys (state) {
    return state.checkout.keys
  },

  jwtOnOff (state) {
    return state.jwtOnOff
  },

  jwtPayload (state) {
    return state.federatedID.jwtPayload
  },

  enableConfirmation (state) {
    return state.enableConfirmation
  },

  srcCorrelationId (state) {
    return state.srcCorrelationId
  },

  cofOnOff (state) {
    return state.cofOnOff
  },

  environment (state) {
    return state.environment
  },

  decryptedPayload (state) {
    return state.decryptedPayload
  },

  srcNetwork (state) {
    return state.srcNetwork
  },

  dynamicDataTypeMastercard (state) {
    return state.dynamicDataTypeMastercard
  },

  dynamicDataTypeVisa (state) {
    return state.dynamicDataTypeVisa
  },

  dynamicDataTypeAmex (state) {
    return state.dynamicDataTypeAmex
  },

  dynamicDataTypeDiscover (state) {
    return state.dynamicDataTypeDiscover
  },

  selectedCheckoutExperience (state) {
    return state.checkout.selectedCheckoutExperience
  },

  selectedProductCategory (state) {
    return state.selectedProductCategory
  },

  shippingAddress (state) {
    return state.checkout.shippingAddress
  },

  billingAddress (state) {
    return state.checkout.billingAddress
  },

  locale (state) {
    return state.storefront.locale
  },

  otherLocale (state) {
    return state.storefront.otherLocale
  },

  scofLocale (state) {
    return state.scofLocale
  },

  scofOtherLocale (state) {
    return state.scofOtherLocale
  },

  payloadTypeIndicatorCheckout (state) {
    return state.checkout.payloadTypeIndicatorCheckout
  },

  payloadTypeIndicatorPayload (state) {
    return state.checkout.payloadTypeIndicatorPayload
  },

  dsaTransactionOptions (state) {
    return state.checkout.dsaTransactionOptions
  },

  preferredLocale (state) {
    if (state.storefront.locale === CONSTANT.CONFIG.OTHER_LOCALE) {
      return state.storefront.otherLocale || ''
    } else {
      return state.storefront.locale
    }
  },

  scofPreferredLocale (state) {
    if (state.scofLocale === CONSTANT.CONFIG.OTHER_LOCALE) {
      return state.scofOtherLocale || ''
    } else {
      return state.scofLocale
    }
  },

  shippingCountryCodes (state) {
    return (state.checkout.shippingCountryCodes || []).filter(val => {
      return val !== ''
    })
  },

  billingCountryCodes (state) {
    return (state.checkout.billingCountryCodes || []).filter(val => {
      return val !== ''
    })
  },

  currency (state) {
    return state.storefront.currency
  },

  consumerEmailAddressRequested (state) {
    return state.checkout.dsaTransactionOptions.consumerEmailAddressRequested || false
  },

  consumerNameRequested (state) {
    return state.checkout.dsaTransactionOptions.consumerNameRequested || false
  },

  consumerPhoneNumberRequested (state) {
    return state.checkout.dsaTransactionOptions.consumerPhoneNumberRequested || false
  },

  validityPeriodMinutes (state) {
    return state.tokenization.validityPeriodMinutes
  },

  srcInitiatorIdByNetwork: (state) => (networkId) => {
    if (!state.checkout.srcId) {
      return state.checkout.srcEntityIds[0].srci[networkId].srcInitiatorId
    }
    return state.checkout.srcId.srci[networkId].srcInitiatorId
  },

  getNativeFlowServiceId: (state) => (networkId) => {
    if (!state.checkout.srcId) {
      return state.checkout.srcEntityIds[0].srci[networkId].additionalProperties.filter(item => item.flowType === SCOF_AUTH_NTS)
    }
    return state.checkout.srcId.srci[networkId].additionalProperties.filter(item => item.flowType === SCOF_AUTH_NTS)
  },

  dpaIdByNetwork: (state) => (networkId) => {
    if (!state.checkout.dpaId) {
      return state.checkout.dpaIds[0].dpa[networkId].dpaId
    }
    return state.checkout.dpaId.dpa[networkId].dpaId
  },

  dynamicDataTypeByNetwork: (state) => (networkName) => {
    return (state['dynamicDataType' + networkName] !== 'NONE') ? state['dynamicDataType' + networkName] : ''
  },

  hostByNetwork: (state) => (networkName) => {
    return state.advanced.paymentProcessor[networkName].HOST ? state.advanced.paymentProcessor[networkName].HOST : ''
  },

  checkoutMethod (state) {
    return state.checkout.checkoutMethod
  },

  sdkJSUrlByNetwork: (state) => (networkName) => {
    let sdkJsUrl = state.advanced.paymentProcessor[networkName].SDK_JS_URL || CONSTANT.CONFIG.SANDBOX_JS_URL[networkName]
    return sdkJsUrl.trim()
  },

  loadedSDKs (state) {
    return state.loadedSDKs
  },

  srcTransactionId (state) {
    return state.srcTransactionId || ''
  },

  consumerJwt (state) {
    return state.consumerJwt
  },

  consumerInfo (state) {
    return state.consumerInfo || {}
  },

  nationalIdentifier (state) {
    return state.checkout.nationalIdentifier
  },

  consumerBillingAddress (state) {
    return state.checkout.consumerBillingAddress || {
      countryCode: 'US'
    }
  },

  accountType (state) {
    return state.accountType
  },

  consumerEmailId (state) {
    return state.consumerEmailId
  },

  nationalIdentifierPreference (state) {
    return state.checkout.nationalIdentifierPreference
  },

  dcfPreference (state) {
    return state.checkout.dcfPreference || 'WITHIN_CHECKOUT'
  },

  mastercardDcfPreference (state) {
    return state.checkout.mastercardDcfPreference
  },

  amexDcfPreference (state) {
    return state.checkout.amexDcfPreference
  },
  visaDcfPreference (state) {
    return state.checkout.visaDcfPreference
  },
  discoverDcfPreference (state) {
    return state.checkout.discoverDcfPreference
  },

  supportMobileLookup (state) {
    return state.advanced.supportMobileLookup
  },

  encryptedcard (state) {
    return state.checkout.encryptedcard
  },

  complianceSettingsObj (state) {
    return state.checkout.complianceSettingsObj
  },

  complianceSettingsCITObj (state) {
    return state.complianceSettingsCITObj
  },

  newUser (state) {
    return state.checkout.newUser
  },

  threeDSPreference (state) {
    return state.threeDSPreference
  },

  nonPaymentSrci (state) {
    return state.checkout.srcEntityIds.filter(item => item.mttConfigId.includes('NONPAYMENT_START'))
  },

  selectedNonPaymentSrci (state) {
    return state.checkout.selectedNonPaymentSrci
  },

  checkoutType (state) {
    return state.checkout.checkoutType
  },

  enableAuthSDKFlow (state) {
    return state.enableAuthSDKFlow
  },

  authExecutionFlow (state) {
    return state.authExecutionFlow
  },

  forceChallenge (state) {
    return state.forceChallenge
  },

  authPresentationStyle (state) {
    return state.authPresentationStyle
  },

  srcClientId (state) {
    return state.advanced.srcClientId
  },

  authResponse (state) {
    return state.advanced.authResponse
  },

  enrollMaskCard (state) {
    return state.advanced.enrollMaskCard
  },

  consumerContactInfo (state) {
    return state.advanced.consumerContactInfo
  },

  rememberMe (state) {
    return state.rememberMe
  },

  recognitionToken (state) {
    return state.recognitionToken
  },

  enableB2bAuthLookupFIDO (state) {
    return state.enableB2bAuthLookupFIDO
  },

  enableNativeIntegrationFlow (state) {
    return state.enableNativeIntegrationFlow
  },

  isNTSFlowEnabled (state) {
    return state.isNTSFlowEnabled
  },

  saveMaskCard (state) {
    return state.advanced.saveMaskCard
  },

  authDpaData (state) {
    return state.authDpaData
  },

  toggleMacsFeaturesList (state) {
    let togglefeature = (state.advanced.paymentProcessor && state.advanced.paymentProcessor['MASTERCARD'] && state.advanced.paymentProcessor['MASTERCARD'].TOGGLE_FEATURES) || {}
    return utils.isJsonString(togglefeature) ? JSON.parse(togglefeature) : togglefeature
  },

  suppressChallenge (state) {
    return state.auth.suppressChallenge
  },

  authenticationMethodTypes (state) {
    return state.auth.authenticationMethodTypes
  },

  payloadRequested (state) {
    return state.auth.payloadRequested
  },

  acquirerData (state) {
    return state.auth.acquirerData
  },

  authPreference (state) {
    return state.auth.authPreference
  },

  tavInfo (state) {
    return state.tavInfo
  },

  scofExecutionFlow (state) {
    return state.scofExecutionFlow
  },

  mdesExecutionFlow (state) {
    return state.mdesExecutionFlow
  },

  thirdPartyFIDO (state) {
    return state.thirdPartyFIDO
  },

  thirdPartyPKI (state) {
    return state.thirdPartyPKI
  },

  pkiFormat (state) {
    return state.pkiFormat
  },

  attestationId (state) {
    const deviceData = state.consumerInfo.consumerDeviceData && state.consumerInfo.consumerDeviceData[localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)]
    if (deviceData) {
      return deviceData.publicKeyId
    } else {
      return null
    }
  },

  pkiAttestationKeyId (state) {
    const deviceData = state.consumerInfo.consumerDeviceData && state.consumerInfo.consumerDeviceData[localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)]
    if (deviceData) {
      return deviceData.pkiAttestationKeyId
    } else {
      return null
    }
  },

  deviceExternalMfaMethodInstanceId (state) {
    const deviceData = state.consumerInfo.consumerDeviceData && state.consumerInfo.consumerDeviceData[localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)]
    if (deviceData) {
      return deviceData.externalMfaMethodInstanceId
    } else {
      return null
    }
  },

  mdesAuthenticateResponse (state) {
    return state.mdesAuthenticateResponse
  },

  scofReturningInfo (state) {
    return state.scofReturningInfo
  },

  merchantSavedCards (state, getters) {
    const cards = state.consumerInfo.merchantCardIds
    const nativeFlowServiceId = getters.getNativeFlowServiceId(0)
    if (cards && state.enableNativeIntegrationFlow === false) {
      const filteredCards = cards.filter(card => card.srcEnvironment === state.environment && card.region === state.region &&
         card.scofMaskedCard.serviceId !== nativeFlowServiceId[0]?.serviceId
      )
      return filteredCards
    } else if (cards && state.enableNativeIntegrationFlow === true) {
      const ntsFilteredCards = cards.filter(card => card.srcEnvironment === state.environment && card.region === state.region &&
        card.scofMaskedCard.serviceId === nativeFlowServiceId[0]?.serviceId
      )
      return ntsFilteredCards
    } else {
      return []
    }
  },

  selectedSavedCardDetails (state) {
    return state.advanced.selectedSavedCardDetails
  },

  selectedBindingDetails (state) {
    return state.advanced.selectedBindingDetails
  },

  isIABFlow (state) {
    return state.isIABFlow
  },

  region (state) {
    return state.region
  },

  c2pSelectedCurrency (state) {
    return state.c2pSelectedCurrency
  },

  traceId (state) {
    return state.traceId
  },

  authenticationFactors (state) {
    return state.authenticationFactors
  },

  enableMPT (state) {
    return state.checkout.enableMPT
  },

  profileOptOut (state) {
    return state.profileOptOut
  },

  b2bAuthLookupReason (state) {
    return state.auth.b2bAuthLookupReason
  },

  isConsumerAuthModuleEnable (state) {
    return state.checkout.isConsumerAuthModuleEnable
  },

  windowRefType (state) {
    return state.checkout.windowRefType
  },

  pflExecutionFlow (state) {
    return state.checkout.pflExecutionFlow
  },

  isConsumerPresent (state) {
    return state.isConsumerPresent
  },

  enableB2bAuthenticate (state) {
    return state.enableB2bAuthenticate
  },

  enableTokenizationConsent (state) {
    return state.enableTokenizationConsent
  },

  enableENCFlow (state) {
    return state.enableENCFlow
  }
}

const actions = {
  incrementQuickCartItem ({ commit }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('incrementQuickCartItem')
        resolve()
      }, 100)
    })
  },

  changeItemPrice ({ commit }, product) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeItemPrice', product)
        resolve()
      }, 100)
    })
  },

  changeItemQuantity ({ commit }, product) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeItemQuantity', product)
        resolve()
      }, 100)
    })
  },

  removeItem ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('removeItem', index)
        resolve()
      }, 100)
    })
  },

  changeCurrency ({ commit }, currency) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeCurrency', currency)
        resolve()
      }, 100)
    })
  },

  changeLocale ({ commit }, locale) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeLocale', locale)
        resolve()
      }, 100)
    })
  },

  changeOtherLocale ({ commit }, locale) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeOtherLocale', locale)
        resolve()
      }, 100)
    })
  },

  changeScofLocale ({ commit }, locale) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeScofLocale', locale)
        resolve()
      }, 100)
    })
  },

  changeScofOtherLocale ({ commit }, locale) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeScofOtherLocale', locale)
        resolve()
      }, 100)
    })
  },

  updatePaymentProcessor ({ commit }, environment) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updatePaymentProcessor', environment)
        resolve()
      }, 100)
    })
  },

  updateKeysByEnv ({ commit }, srcKeys) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateKeysByEnv', srcKeys)
        resolve()
      }, 100)
    })
  },

  resetConfig ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('resetConfig', index)
        resolve()
      }, 100)
    })
  },

  updateCryptoFormat ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateCryptoFormat', index)
        resolve()
      }, 100)
    })
  },

  updateValidityPeriodMinutes ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateValidityPeriodMinutes', index)
        resolve()
      }, 100)
    })
  },

  updateDynamicCVC2Support ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDynamicCVC2Support', index)
        resolve()
      }, 100)
    })
  },

  updateOriginUrl ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateOriginUrl', index)
        resolve()
      }, 100)
    })
  },

  updateShippingCountryCodes ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateShippingCountryCodes', index)
        resolve()
      }, 100)
    })
  },

  updateShippingAddress ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateShippingAddress', index)
        resolve()
      }, 100)
    })
  },

  updateBillingCountryCodes ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateBillingCountryCodes', index)
        resolve()
      }, 100)
    })
  },

  updateBillingAddress ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateBillingAddress', index)
        resolve()
      }, 100)
    })
  },

  updateDSATransactionOptions ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDSATransactionOptions', index)
        resolve()
      }, 100)
    })
  },

  updateSrcEntityIds ({ commit }, srcEntityIds) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSrcEntityIds', srcEntityIds)
        resolve()
      }, 100)
    })
  },

  updateDpaIds ({ commit }, dpaIds) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDpaIds', dpaIds)
        resolve()
      }, 100)
    })
  },

  updateSrcEntityId ({ commit }, entityId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSrcEntityId', entityId)
        resolve()
      }, 100)
    })
  },

  updateDpaId ({ commit }, result) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDpaId', result)
        resolve()
      }, 100)
    })
  },

  updateSrcId ({ commit }, result) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSrcId', result)
        resolve()
      }, 100)
    })
  },

  updateIsSRCCheckoutDisabled ({ commit }, isDisabled) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateIsSRCCheckoutDisabled', isDisabled)
        resolve()
      }, 100)
    })
  },

  updateJwtOnOff ({ commit }, jwtOnOff) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateJwtOnOff', jwtOnOff)
        resolve()
      }, 100)
    })
  },

  updateJwtPayload ({ commit }, jwtPayload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateJwtPayload', jwtPayload)
        resolve()
      }, 100)
    })
  },

  updateFederatedToken ({ commit }, federatedToken) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateFederatedToken', federatedToken)
        resolve()
      }, 100)
    })
  },

  updateUserAccessToken ({ commit }, userAccessToken) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateUserAccessToken', userAccessToken)
        resolve()
      }, 100)
    })
  },

  adminUserName ({ commit }, adminUsername) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('adminUserName', adminUsername)
        resolve()
      }, 100)
    })
  },

  updateEnableConfirmation ({ commit }, flag) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateEnableConfirmation', flag)
        resolve()
      }, 100)
    })
  },

  updateDecryptedPayload ({ commit }, decryptedPayload) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDecryptedPayload', decryptedPayload)
        resolve()
      }, 100)
    })
  },

  updateCOFOnOff ({ commit }, cofOnOff) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateCOFOnOff', cofOnOff)
        resolve()
      }, 100)
    })
  },

  updateCOFDigitalCardId ({ commit }, cofDigitalCardId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateCOFDigitalCardId', cofDigitalCardId)
        resolve()
      }, 100)
    })
  },

  updateCOFSrciTxId ({ commit }, cofSrciTxId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateCOFSrciTxId', cofSrciTxId)
        resolve()
      }, 100)
    })
  },

  updateSRCCorrelationId ({ commit }, srcCorrelationId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSRCCorrelationId', srcCorrelationId)
        resolve()
      }, 100)
    })
  },

  srcNetwork ({ commit }, srcNetwork) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('srcNetwork', srcNetwork)
        resolve()
      }, 100)
    })
  },

  updateEnvironment ({ commit }, environment) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateEnvironment', environment)
        resolve(environment)
      }, 100)
    })
  },

  updateDynamicDataTypeMastercard ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDynamicDataTypeMastercard', value)
        resolve()
      }, 100)
    })
  },

  updateDynamicDataTypeVisa ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDynamicDataTypeVisa', value)
        resolve()
      }, 100)
    })
  },

  updateDynamicDataTypeAmex ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDynamicDataTypeAmex', value)
        resolve()
      }, 100)
    })
  },

  updateDynamicDataTypeDiscover ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDynamicDataTypeDiscover', value)
        resolve()
      }, 100)
    })
  },

  updateSelectedCheckoutExperience ({ commit }, selectedCheckoutExperience) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSelectedCheckoutExperience', selectedCheckoutExperience)
        resolve()
      }, 100)
    })
  },

  changeProductCategory ({ commit }, selectedProductCategory) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeProductCategory', selectedProductCategory)
        resolve()
      }, 100)
    })
  },

  updatePayloadTypeIndicatorCheckout ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updatePayloadTypeIndicatorCheckout', value)
        resolve()
      }, 100)
    })
  },

  updatePayloadTypeIndicatorPayload ({ commit }, value) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updatePayloadTypeIndicatorPayload', value)
        resolve()
      }, 100)
    })
  },

  updateCheckoutMethod ({ commit }, checkoutMethod) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('commitCheckoutMethod', checkoutMethod)
        resolve()
      }, 100)
    })
  },

  loadedSDKs ({ commit }, value) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('loadedSDKs', value)
        resolve()
      }, 100)
    })
  },

  srcTransactionId ({ commit }, srcTransactionId) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('srcTransactionId', srcTransactionId)
        resolve()
      }, 100)
    })
  },

  updateConsumerJwt ({ commit }, consumerJwt) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('changeConsumerJwt', consumerJwt)
        resolve()
      }, 100)
    })
  },

  updateConsumerInfo ({ commit }, consumerName) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('changeConsumerInfo', consumerName)
        resolve()
      }, 100)
    })
  },

  changeNationalIdentifier ({ commit }, nationalIdentifier) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeNationalIdentifier', nationalIdentifier)
        resolve()
      }, 100)
    })
  },

  changeAccountType ({ commit }, accountType) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeAccountType', accountType)
        resolve()
      }, 100)
    })
  },

  changeConsumerBillingAddress ({ commit }, consumerBillingAddress) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('changeConsumerBillingAddress', consumerBillingAddress)
        resolve()
      }, 100)
    })
  },

  consumerEmailId ({ commit }, emailId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('consumerEmailId', emailId)
        resolve()
      }, 100)
    })
  },

  updateNationalIdPreference ({ commit }, nationalIdentifier) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('nationalIdentifierPreference', nationalIdentifier)
        resolve()
      }, 100)
    })
  },

  updateDcfPreference ({ commit }, dcfPreference) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDcfPreference', dcfPreference)
        resolve()
      }, 100)
    })
  },

  updateMastercardDcfPreference ({ commit }, mastercardDcfPreference) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateMastercardDcfPreference', mastercardDcfPreference)
        resolve()
      }, 100)
    })
  },

  updateAmexDcfPreference ({ commit }, amexDcfPreference) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateAmexDcfPreference', amexDcfPreference)
        resolve()
      }, 100)
    })
  },

  updateVisaDcfPreference ({ commit }, visaDcfPreference) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateVisaDcfPreference', visaDcfPreference)
        resolve()
      }, 100)
    })
  },

  updateDiscoverDcfPreference ({ commit }, discoverDcfPreference) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateDiscoverDcfPreference', discoverDcfPreference)
        resolve()
      }, 100)
    })
  },

  updateSupportMobileLookup ({ commit }, supportMobileLookup) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateSupportMobileLookup', supportMobileLookup)
        resolve()
      }, 100)
    })
  },

  updateConfirmPayment ({ commit }, confirmPayment) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateConfirmPayment', confirmPayment)
        resolve()
      }, 100)
    })
  },

  updateEncryptedcard ({ commit }, encryptedcard) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateEncryptedcard', encryptedcard)
        resolve()
      }, 100)
    })
  },

  updateComplianceSettingsObj ({ commit }, complianceSettingsObj) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateComplianceSettingsObj', complianceSettingsObj)
        resolve()
      }, 100)
    })
  },

  updateComplianceSettingsCITObj ({ commit }, complianceSettingsCITObj) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateComplianceSettingsCITObj', complianceSettingsCITObj)
        resolve()
      }, 100)
    })
  },

  updateNewUser ({ commit }, newUser) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('updateNewUser', newUser)
        resolve()
      }, 100)
    })
  },

  updateCheckoutType ({ commit }, checkoutType) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setCheckoutType', checkoutType)
        resolve()
      }, 100)
    })
  },

  updateThreeDSPreference ({ commit }, threeDSPreference) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setThreeDSPreference', threeDSPreference)
        resolve()
      }, 100)
    })
  },

  updateSelectedNonPaymentSrci ({ commit }, selectedNonPaymentSrci) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setSelectedNonPaymentSrci', selectedNonPaymentSrci)
        resolve()
      }, 100)
    })
  },

  updateB2bAuthLookupReason ({ commit }, index) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setB2bAuthLookupReason', index)
        resolve()
      }, 100)
    })
  },

  async updateEnableAuthSDKFlow ({ state, commit }, enableAuthSDKFlow) {
    const authSDKKey = 'AUTH_SDK_JS_URL'
    const keyAsPerEnv = state.region === CONSTANT.REGION.GLOBAL ? authSDKKey : authSDKKey.concat('_', CONSTANT.REGION.IND)
    const authScriptUrl = state.advanced.paymentProcessor['MASTERCARD'][keyAsPerEnv]
    return new Promise(async (resolve, reject) => {
      if (enableAuthSDKFlow) {
        const response = await sharedService.loadScript(authScriptUrl, 'auth').catch((err) => {
          reject(err)
        })
        if (response) {
          commit('setEnableAuthSDKFlow', enableAuthSDKFlow)
          resolve()
        }
      } else {
        sharedService.removeScriptById('authSDK')
        commit('setEnableAuthSDKFlow', enableAuthSDKFlow)
        resolve()
      }
    })
  },

  updateRememberMeConsent ({ commit }, rememberMe) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setRememberMeValue', rememberMe)
        resolve()
      }, 100)
    })
  },

  updateRecognitionToken ({ commit }, recognitionToken) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('setRecognitionToken', recognitionToken)
        resolve()
      }, 100)
    })
  },

  updateEnableB2bAuthLookupFIDO ({ commit }, enableB2bAuthLookupFIDO) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setEnableB2bAuthLookupFIDO', enableB2bAuthLookupFIDO)
        resolve()
      }, 100)
    })
  },

  updateEnableB2bAuthenticate ({ commit }, enableB2bAuthenticate) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setEnableB2bAuthenticate', enableB2bAuthenticate)
        resolve()
      }, 100)
    })
  },

  updateEnableTokenizationConsent ({ commit }, enableTokenizationConsent) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setEnableTokenizationConsent', enableTokenizationConsent)
        resolve()
      }, 100)
    })
  },

  updateEnableENCFlow ({ commit }, enableENCFlow) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setEnableENCFlow', enableENCFlow)
        resolve()
      }, 100)
    })
  },

  updateEnableNativeIntegrationFlow ({ commit }, enableNativeIntegrationFlow) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setEnableNativeIntegrationFlow ', enableNativeIntegrationFlow)
        resolve()
      }, 100)
    })
  },

  updateEnableNTSFlow ({ commit }, isNTSFlowEnabled) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setEnableNTSFlow ', isNTSFlowEnabled)
        resolve()
      }, 100)
    })
  },

  updateSaveMaskCard ({ commit }, saveMaskCard) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setSaveMaskcard', saveMaskCard)
        resolve()
      }, 100)
    })
  },

  updateSelectedSavedCardDetails ({ commit }, selectedCard) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setSelectedSavedCardDetails', selectedCard)
        resolve()
      }, 100)
    })
  },

  updateSelectedBindingDetails ({ commit }, details) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setSelectedBindingDetails', details)
        resolve()
      }, 100)
    })
  },

  updateAuthDpaData ({ commit }, authDpaData) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setAuthDpaData', authDpaData)
        resolve()
      }, 100)
    })
  },

  updateSuppressChallenge ({ commit }, suppressChallenge) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setSuppressChallenge', suppressChallenge)
        resolve()
      }, 100)
    })
  },

  updateAuthenticationMethodTypes ({ commit }, authenticationMethodTypes) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setAuthenticationMethodTypes', authenticationMethodTypes)
        resolve()
      }, 100)
    })
  },

  updatePayloadRequested ({ commit }, payloadRequested) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setPayloadRequested', payloadRequested)
        resolve()
      }, 100)
    })
  },

  updateAcquirerData ({ commit }, acquirerData) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setAcquirerData', acquirerData)
        resolve()
      }, 100)
    })
  },

  updateAuthPreference ({ commit }, authPreference) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setAuthPreference', authPreference)
        resolve()
      }, 100)
    })
  },

  updateTavInfo ({ commit }, tavInfo) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setTavInfo', tavInfo)
        resolve()
      }, 100)
    })
  },

  updateScofExecutionFlow ({ commit }, scofExecutionFlow) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setScofExecutionFlow', scofExecutionFlow)
        resolve()
      }, 100)
    })
  },

  updateMdesExecutionFlow ({ commit }, mdesExecutionFlow) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setMdesExecutionFlow', mdesExecutionFlow)
        resolve()
      }, 100)
    })
  },

  updateThirdPartyFIDO ({ commit }, thirdPartyFIDO) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setThirdPartyFIDO', thirdPartyFIDO)
        resolve()
      }, 100)
    })
  },

  updateThirdPartyPKI ({ commit }, thirdPartyPKI) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setThirdPartyPKI', thirdPartyPKI)
        resolve()
      }, 100)
    })
  },

  updatePkiFormat ({ commit }, pkiFormat) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setPkiFormat', pkiFormat)
        resolve()
      }, 100)
    })
  },

  updateConsumerDeviceData ({ commit }, { fidoData, bindingDetails }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setConsumerDeviceData', { fidoData, bindingDetails })
        resolve()
      }, 100)
    })
  },

  updateMdesAuthenticateResponse ({ commit }, mdesAuthenticateResponse) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setMdesAuthenticateResponse', mdesAuthenticateResponse)
        resolve()
      }, 100)
    })
  },

  updateScofReturningInfo ({ commit }, scofReturningInfo) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setScofReturningInfo', scofReturningInfo)
        resolve()
      }, 100)
    })
  },

  updateRegion ({ commit }, region) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setRegion', region)
        resolve(region)
      }, 100)
    })
  },

  updateC2PCurrency ({ commit }, currency) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setC2PCurrency', currency)
        resolve(currency)
      }, 100)
    })
  },

  updateTraceId ({ commit }, traceId) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setTraceId', traceId)
        resolve(traceId)
      }, 100)
    })
  },

  updateAuthenticationFactors ({ commit }, authenticationFactors) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setAuthenticationFactors', authenticationFactors)
        resolve(authenticationFactors)
      }, 100)
    })
  },

  updateMPTFlow ({ commit }, enableMPT) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setMPTFlow', enableMPT)
        resolve(enableMPT)
      }, 100)
    })
  },

  updateProfileOptOut ({ commit }, profileOptOut) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setProfileOptOut', profileOptOut)
        resolve(profileOptOut)
      }, 100)
    })
  },

  updateIsIABFlow ({ commit }, isIABFlow) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('setIsIABFlow', isIABFlow)
        resolve()
      }, 100)
    })
  },

  updateConsumerAuthModule ({ commit }, consumerAuthenticationModule) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setConsumerAuthModule', consumerAuthenticationModule)
        resolve()
      }, 100)
    })
  },

  updateWindowRefType ({ commit }, windowRefType) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setWindowRefType', windowRefType)
        resolve()
      }, 100)
    })
  },

  updatePflExecutionFlow ({ commit }, pflExecutionFlow) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setPflExecutionFlow', pflExecutionFlow)
        resolve()
      }, 100)
    })
  },

  updateConsumerPresent ({ commit }, isConsumerPresent) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('setConsumerPresent', isConsumerPresent)
        resolve()
      }, 100)
    })
  }
}

const mutations = {

  incrementQuickCartItem (state) {
    var product = {
      productId: cuid(),
      price: 100,
      quantity: 1
    }
    state.storefront.quickCart.products.push(product)
    state.storefront.quickCart.totalPrice = configurationService.updateTotalPrice(state.storefront.quickCart.products)
    configurationService.setConfigData(state)
  },

  removeItem (state, index) {
    state.storefront.quickCart.products.splice(index, 1)
    state.storefront.quickCart.totalPrice = configurationService.updateTotalPrice(state.storefront.quickCart.products)
    configurationService.setConfigData(state)
  },

  changeItemPrice (state, product) {
    _.each(state.storefront.quickCart.products, (prod) => {
      if (prod.productId === product.productId) {
        prod.price = product.price
      }
    })
    state.storefront.quickCart.totalPrice = configurationService.updateTotalPrice(state.storefront.quickCart.products)
    configurationService.setConfigData(state)
  },

  changeItemQuantity (state, product) {
    _.each(state.storefront.quickCart.products, (prod) => {
      if (prod.productId === product.productId) {
        prod.quantity = product.quantity
      }
    })
    state.storefront.quickCart.totalPrice = configurationService.updateTotalPrice(state.storefront.quickCart.products)
    configurationService.setConfigData(state)
  },

  changeCurrency (state, currency) {
    state.storefront.currency = currency
    configurationService.setConfigData(state)
  },

  changeLocale (state, locale) {
    state.storefront.locale = locale
    configurationService.setConfigData(state)
  },

  changeOtherLocale (state, locale) {
    state.storefront.otherLocale = locale
    configurationService.setConfigData(state)
  },

  changeScofLocale (state, locale) {
    state.scofLocale = locale
    configurationService.setConfigData(state)
  },

  changeScofOtherLocale (state, locale) {
    state.scofOtherLocale = locale
    configurationService.setConfigData(state)
  },

  resetConfig (state) {
    state = configurationService.initialConfiguration
    configurationService.resetConfig(state)
  },

  updatePaymentProcessor (state, paymentProcessor) {
    state.advanced.paymentProcessor = paymentProcessor
    configurationService.setConfigData(state)
  },

  updateKeysByEnv (state, srcKeys) {
    state.checkout.keys = srcKeys
  },

  updateCryptoFormat (state, cryptoFormat) {
    state.tokenization.cryptoFormat = cryptoFormat
    configurationService.setConfigData(state)
  },

  updateValidityPeriodMinutes (state, validityPeriodMinutes) {
    state.tokenization.validityPeriodMinutes = validityPeriodMinutes
    configurationService.setConfigData(state)
  },

  updateDynamicCVC2Support (state, dynamicCVC2Support) {
    state.tokenization.dynamicCVC2Support = dynamicCVC2Support
    configurationService.setConfigData(state)
  },

  updateOriginUrl (state, originUrl) {
    state.checkout.originUrl = originUrl
    configurationService.setConfigData(state)
  },

  updateShippingCountryCodes (state, shippingCountryCodes) {
    shippingCountryCodes = shippingCountryCodes ? shippingCountryCodes.replace(/\s/g, '').split(',') : []
    state.checkout.shippingCountryCodes = shippingCountryCodes
    configurationService.setConfigData(state)
  },

  updateShippingAddress (state, shippingAddress) {
    state.checkout.shippingAddress = shippingAddress
    configurationService.setConfigData(state)
  },

  updateBillingCountryCodes (state, billingCountryCodes) {
    billingCountryCodes = billingCountryCodes ? billingCountryCodes.replace(/\s/g, '').split(',') : []
    state.checkout.billingCountryCodes = billingCountryCodes
    configurationService.setConfigData(state)
  },

  updateBillingAddress (state, billingAddress) {
    state.checkout.billingAddress = billingAddress
    configurationService.setConfigData(state)
  },

  updateDSATransactionOptions (state, dpaTransactionOptions) {
    state.checkout.dpaTransactionOptions = dpaTransactionOptions
    state.checkout.dsaTransactionOptions = dpaTransactionOptions
    configurationService.setConfigData(state)
  },

  updateSrcEntityIds (state, srcEntityIds) {
    state.checkout.srcEntityIds = srcEntityIds
    configurationService.setConfigData(state)
  },

  updateDpaIds (state, dpaIds) {
    state.checkout.dpaIds = dpaIds
    configurationService.setConfigData(state)
  },

  updateSrcEntityId (state, entityId) {
    state.checkout.srcId = entityId
    configurationService.setConfigData(state)
  },

  updateDpaId (state, dpaId) {
    state.checkout.dpaId = dpaId
    configurationService.setConfigData(state)
  },

  updateSrcId (state, srcId) {
    state.checkout.srcId = srcId
    configurationService.setConfigData(state)
  },

  updateIsSRCCheckoutDisabled (state, isDisabled) {
    state.isSRCCheckoutDisabled = isDisabled
    configurationService.setConfigData(state)
  },

  updateJwtOnOff (state, jwtOnOff) {
    state.jwtOnOff = jwtOnOff
    configurationService.setConfigData(state)
  },

  updateJwtPayload (state, jwtPayload) {
    state.federatedID.jwtPayload = jwtPayload
    configurationService.setConfigData(state)
  },

  updateFederatedToken (state, federatedToken) {
    state.federatedToken = federatedToken
    configurationService.setConfigData(state)
  },

  updateUserAccessToken (state, userAccessToken) {
    state.userAccessToken = userAccessToken
  },

  adminUserName (state, adminUserName) {
    state.adminUserName = adminUserName
  },

  updateEnableConfirmation (state, flag) {
    state.enableConfirmation = flag
    configurationService.setConfigData(state)
  },

  updateDecryptedPayload (state, payload) {
    state.decryptedPayload = payload
    configurationService.setConfigData(state)
  },

  updateCOFOnOff (state, cofOnOff) {
    state.cofOnOff = cofOnOff
    configurationService.setConfigData(state)
  },

  updateCOFDigitalCardId (state, cofDigitalCardId) {
    state.advanced.cofDigitalCardId = cofDigitalCardId
    configurationService.setConfigData(state)
  },

  updateCOFSrciTxId (state, cofSrciTxId) {
    state.advanced.cofSrciTxId = cofSrciTxId
    configurationService.setConfigData(state)
  },

  updateSRCCorrelationId (state, srcCorrelationId) {
    state.srcCorrelationId = srcCorrelationId
    configurationService.setConfigData(state)
  },

  srcNetwork (state, srcNetwork) {
    state.srcNetwork = srcNetwork
    configurationService.setConfigData(state)
  },

  updateEnvironment (state, environment) {
    state.environment = environment
    configurationService.setConfigData(state)
  },

  updateDynamicDataTypeMastercard (state, dynamicDataType) {
    state.dynamicDataTypeMastercard = dynamicDataType
    configurationService.setConfigData(state)
  },

  updateDynamicDataTypeVisa (state, dynamicDataType) {
    state.dynamicDataTypeVisa = dynamicDataType
    configurationService.setConfigData(state)
  },

  updateDynamicDataTypeAmex (state, dynamicDataType) {
    state.dynamicDataTypeAmex = dynamicDataType
    configurationService.setConfigData(state)
  },

  updateDynamicDataTypeDiscover (state, dynamicDataType) {
    state.dynamicDataTypeDiscover = dynamicDataType
    configurationService.setConfigData(state)
  },

  updateSelectedCheckoutExperience (state, selectedCheckoutExperience) {
    state.checkout.selectedCheckoutExperience = selectedCheckoutExperience
    configurationService.setConfigData(state)
  },

  changeProductCategory (state, selectedProductCategory) {
    state.selectedProductCategory = selectedProductCategory
    configurationService.setConfigData(state)
  },

  updatePayloadTypeIndicatorCheckout (state, payloadTypeIndicatorCheckout) {
    state.checkout.payloadTypeIndicatorCheckout = payloadTypeIndicatorCheckout
    configurationService.setConfigData(state)
  },

  updatePayloadTypeIndicatorPayload (state, payloadTypeIndicatorPayload) {
    state.checkout.payloadTypeIndicatorPayload = payloadTypeIndicatorPayload
    configurationService.setConfigData(state)
  },

  commitCheckoutMethod (state, checkoutMethod) {
    state.checkout.checkoutMethod = checkoutMethod
    configurationService.setConfigData(state)
  },

  loadedSDKs (state, sdks) {
    state.loadedSDKs = sdks
    configurationService.setConfigData(state)
  },

  srcTransactionId (state, srcTransactionId) {
    state.srcTransactionId = srcTransactionId
    configurationService.setConfigData(state)
  },

  changeConsumerJwt (state, consumerJwt) {
    state.consumerJwt = consumerJwt
    configurationService.setConfigData(state)
  },

  changeConsumerInfo (state, consumerName) {
    state.consumerInfo = consumerName
    configurationService.setConfigData(state)
  },

  changeNationalIdentifier (state, nationalIdentifier) {
    state.checkout.nationalIdentifier = nationalIdentifier
    configurationService.setConfigData(state)
  },

  changeConsumerBillingAddress (state, consumerBillingAddress) {
    state.checkout.consumerBillingAddress = consumerBillingAddress
    configurationService.setConfigData(state)
  },

  resetConsumerBillingAddress (state, consumerBillingAddress) {
    state.checkout.consumerBillingAddress = {}
    configurationService.setConfigData(state)
  },

  changeAccountType (state, accountType) {
    state.accountType = accountType
    configurationService.setConfigData(state)
  },

  consumerEmailId (state, emailId) {
    state.consumerEmailId = emailId
    configurationService.setConfigData(state)
  },

  updateNationalIdPreference (state, nationalIdentifierPreference) {
    state.checkout.nationalIdentifierPreference = nationalIdentifierPreference
    configurationService.setConfigData(state)
  },

  updateDcfPreference (state, dcfPreference) {
    state.checkout.dcfPreference = dcfPreference
    configurationService.setConfigData(state)
  },

  updateMastercardDcfPreference (state, mastercardDcfPreference) {
    state.checkout.mastercardDcfPreference = mastercardDcfPreference
    configurationService.setConfigData(state)
  },

  updateAmexDcfPreference (state, amexDcfPreference) {
    state.checkout.amexDcfPreference = amexDcfPreference
    configurationService.setConfigData(state)
  },

  updateVisaDcfPreference (state, visaDcfPreference) {
    state.checkout.visaDcfPreference = visaDcfPreference
    configurationService.setConfigData(state)
  },

  updateDiscoverDcfPreference (state, discoverDcfPreference) {
    state.checkout.discoverDcfPreference = discoverDcfPreference
    configurationService.setConfigData(state)
  },

  updateSupportMobileLookup (state, supportMobileLookup) {
    state.advanced.supportMobileLookup = supportMobileLookup
    configurationService.setConfigData(state)
  },

  updateConfirmPayment (state, confirmPayment) {
    state.checkout.confirmPayment = confirmPayment
    configurationService.setConfigData(state)
  },

  updateEncryptedcard (state, encryptedcard) {
    state.checkout.encryptedcard = encryptedcard
    configurationService.setConfigData(state)
  },

  updateComplianceSettingsObj (state, complianceSettingsObj) {
    state.checkout.complianceSettingsObj = complianceSettingsObj
    configurationService.setConfigData(state)
  },

  updateComplianceSettingsCITObj (state, complianceSettingsCITObj) {
    state.complianceSettingsCITObj = complianceSettingsCITObj
    configurationService.setConfigData(state)
  },

  updateNewUser (state, newUser) {
    state.checkout.newUser = newUser
    configurationService.setConfigData(state)
  },

  setCheckoutType (state, checkoutType) {
    state.checkout.checkoutType = checkoutType
    configurationService.setConfigData(state)
  },

  setThreeDSPreference (state, threeDSPreference) {
    state.threeDSPreference = threeDSPreference
    configurationService.setConfigData(state)
  },

  setSelectedNonPaymentSrci (state, selectedNonPaymentSrci) {
    state.checkout.selectedNonPaymentSrci = selectedNonPaymentSrci
    configurationService.setConfigData(state)
  },

  setEnableAuthSDKFlow (state, enableAuthSDKFlow) {
    state.enableAuthSDKFlow = enableAuthSDKFlow
    configurationService.setConfigData(state)
  },

  setAuthExecutionFlow (state, authExecutionFlow) {
    state.authExecutionFlow = authExecutionFlow
    configurationService.setConfigData(state)
  },

  setForceChallenge (state, forceChallenge) {
    state.forceChallenge = forceChallenge
    configurationService.setConfigData(state)
  },

  setAuthPresentationExp (state, authPresentationStyle) {
    state.authPresentationStyle = authPresentationStyle
    configurationService.setConfigData(state)
  },

  setSrcClientId (state, srcClientId) {
    state.advanced.srcClientId = srcClientId
    configurationService.setConfigData(state)
  },

  setAuthResponse (state, authResponse) {
    state.advanced.authResponse = authResponse
    configurationService.setConfigData(state)
  },

  setEnrollMaskCard (state, enrollMaskCard) {
    state.advanced.enrollMaskCard = enrollMaskCard
    configurationService.setConfigData(state)
  },

  setNativeFlowServiceId (state, serviceId) {
    state.nativeFlowServiceId = serviceId
    configurationService.setConfigData(state)
  },

  setConsumerContactInfo (state, consumerInfo) {
    state.advanced.consumerContactInfo = consumerInfo
    configurationService.setConfigData(state)
  },

  setRememberMeValue (state, rememberMe) {
    state.rememberMe = rememberMe
    configurationService.setConfigData(state)
  },

  setRecognitionToken (state, recognitionToken) {
    state.recognitionToken = recognitionToken
    configurationService.setConfigData(state)
  },

  setEnableB2bAuthLookupFIDO (state, enableB2bAuthLookupFIDO) {
    state.enableB2bAuthLookupFIDO = enableB2bAuthLookupFIDO
    configurationService.setConfigData(state)
  },

  setEnableB2bAuthenticate (state, enableB2bAuthenticate) {
    state.enableB2bAuthenticate = enableB2bAuthenticate
    configurationService.setConfigData(state)
  },

  setEnableTokenizationConsent (state, enableTokenizationConsent) {
    state.enableTokenizationConsent = enableTokenizationConsent
    configurationService.setConfigData(state)
  },

  setEnableENCFlow (state, enableENCFlow) {
    state.enableENCFlow = enableENCFlow
    configurationService.setConfigData(state)
  },

  setEnableNativeIntegrationFlow (state, enableNativeIntegrationFlow) {
    state.enableNativeIntegrationFlow = enableNativeIntegrationFlow
    configurationService.setConfigData(state)
  },

  setEnableNTSFlow (state, isNTSFlowEnabled) {
    state.isNTSFlowEnabled = isNTSFlowEnabled
    configurationService.setConfigData(state)
  },

  setSaveMaskCard (state, saveMaskCard) {
    state.advanced.saveMaskCard = saveMaskCard
    configurationService.setConfigData(state)
  },

  setSelectedSavedCardDetails (state, selectedCard) {
    state.advanced.selectedSavedCardDetails = selectedCard
    configurationService.setConfigData(state)
  },

  setSelectedBindingDetails (state, details) {
    state.advanced.selectedBindingDetails = details
    configurationService.setConfigData(state)
  },

  setAuthDpaData (state, authDpaData) {
    state.authDpaData = authDpaData
    configurationService.setConfigData(state)
  },

  setSuppressChallenge (state, suppressChallenge) {
    state.auth.suppressChallenge = suppressChallenge
    configurationService.setConfigData(state)
  },

  setAuthenticationMethodTypes (state, authenticationMethodTypes) {
    state.auth.authenticationMethodTypes = authenticationMethodTypes
    configurationService.setConfigData(state)
  },

  setPayloadRequested (state, payloadRequested) {
    state.auth.payloadRequested = payloadRequested
    configurationService.setConfigData(state)
  },

  setAcquirerData (state, acquirerData) {
    state.auth.acquirerData = acquirerData
    configurationService.setConfigData(state)
  },

  setAuthPreference (state, authPreference) {
    state.auth.authPreference = authPreference
    configurationService.setConfigData(state)
  },

  setTavInfo (state, tavInfo) {
    state.tavInfo = tavInfo
    configurationService.setConfigData(state)
  },

  setScofExecutionFlow (state, scofExecutionFlow) {
    state.scofExecutionFlow = scofExecutionFlow
    configurationService.setConfigData(state)
  },

  setMdesExecutionFlow (state, mdesExecutionFlow) {
    state.mdesExecutionFlow = mdesExecutionFlow
    configurationService.setConfigData(state)
  },

  setThirdPartyFIDO (state, thirdPartyFIDO) {
    state.thirdPartyFIDO = thirdPartyFIDO
    configurationService.setConfigData(state)
  },

  setThirdPartyPKI (state, thirdPartyPKI) {
    state.thirdPartyPKI = thirdPartyPKI
    configurationService.setConfigData(state)
  },

  setPkiFormat (state, pkiFormat) {
    state.pkiFormat = pkiFormat
    configurationService.setConfigData(state)
  },

  setConsumerDeviceData (state, { fidoData, bindingDetails }) {
    const deviceId = localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)
    const deviceData = {
      [state.thirdPartyPKI ? 'pkiAttestationKeyId' : 'publicKeyId']: state.thirdPartyPKI ? fidoData.keyId : fidoData?.id,
      externalMfaMethodInstanceId: bindingDetails.externalMfaMethodInstanceId,
      mfaMethodInstanceId: bindingDetails.mfaMethodInstanceId
    }
    if (!state.consumerInfo.consumerDeviceData || state.consumerInfo.consumerDeviceData === null) {
      state.consumerInfo.consumerDeviceData = {}
    }
    state.consumerInfo['consumerDeviceData'][deviceId] = deviceData
    configurationService.setConfigData(state)
  },

  setMdesAuthenticateResponse (state, mdesAuthenticateResponse) {
    state.mdesAuthenticateResponse = mdesAuthenticateResponse
    configurationService.setConfigData(state)
  },

  setScofReturningInfo (state, scofReturningInfo) {
    state.scofReturningInfo = scofReturningInfo
    configurationService.setConfigData(state)
  },

  setRegion (state, region) {
    state.region = region
    configurationService.setConfigData(state)
  },

  setC2PCurrency (state, currency) {
    state.c2pSelectedCurrency = currency
    configurationService.setConfigData(state)
  },

  setTraceId (state, traceId) {
    state.traceId = traceId
    configurationService.setConfigData(state)
  },

  setAuthenticationFactors (state, authenticationFactors) {
    state.authenticationFactors = authenticationFactors
    configurationService.setConfigData(state)
  },

  setMPTFlow (state, enableMPT) {
    state.checkout.enableMPT = enableMPT
    configurationService.setConfigData(state)
  },

  setProfileOptOut (state, profileOptOut) {
    state.profileOptOut = profileOptOut
    configurationService.setConfigData(state)
  },

  setB2bAuthLookupReason (state, b2bAuthLookupReason) {
    state.auth.b2bAuthLookupReason = b2bAuthLookupReason
    configurationService.setConfigData(state)
  },

  setIsIABFlow (state, isIABFlow) {
    state.isIABFlow = isIABFlow
    configurationService.setConfigData(state)
  },

  setConsumerAuthModule (state, consumerAuthenticationModule) {
    state.checkout.isConsumerAuthModuleEnable = consumerAuthenticationModule
    configurationService.setConfigData(state)
  },

  setWindowRefType (state, windowRefType) {
    state.checkout.windowRefType = windowRefType
    configurationService.setConfigData(state)
  },

  setPflExecutionFlow (state, pflExecutionFlow) {
    state.checkout.pflExecutionFlow = pflExecutionFlow
    configurationService.setConfigData(state)
  },

  setConsumerPresent (state, isConsumerPresent) {
    state.isConsumerPresent = isConsumerPresent
    configurationService.setConfigData(state)
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
